<template>
    <div>
        <PageTitle :pages="pages" :title="titles.packsList"/>
        <div class="card">
            <div class="card-body">
                <h4 class="header-title mt-0">{{titles.packConfigTitle}} :
                    {{this.$cookies.get('pack').domain.name}} -
                    <span v-if="this.$cookies.get('pack').country.name!='default'"> {{this.$cookies.get('pack').country.name}} - </span>
                    {{this.$cookies.get('pack').typePack.label}}</h4>
                <Tab :DomainPack="domain"
                     :currentTab="tabs[0]"
                     :currentTabComponent="tabs[0].component" :show="showTab"
                     :showCountry="showCountry"
                     :showDomain="showDomain"
                     :tabs="tabs"/>
            </div>
        </div>
    </div>
</template>

<script>
    import PageTitle from '../../common/PageTitle';
    import Tab from '../../common/Tab';
    import {titles} from '../../../utils/general/titles.js';
    import {name} from '../../../utils/general/routers.js';
    import {domain} from '../../shared/models/domain';

    export default {
        name: 'PackForm',
        components: {PageTitle, Tab},
        data() {
            return {
                titles,
                showDomain: false,
                showCountry: false,
                showTab: true,
                title: titles.domainAddExpression,
                pages: [],
                domain: domain(),
                tabs: [
                    {
                        name: 'Infos',
                        component: 'PackInfo'
                    },
                    {
                        name: 'Fonctionnalités',
                        component: 'FunctionalityInfo'
                    }
                ]
            };
        },
        created() {
            this.tabSelected = this.tabs[0].component;
            this.pages.push(
                {
                    name: titles.settings,
                    router: name.settings,
                    active: false
                },
                {
                    name: this.titles.packsList,
                    router: name.packList,
                    active: false
                },
                {
                    name: this.titles.packConfigTitle,
                    router: null,
                    active: true
                }
            );
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/appStyle.css';
</style>
